import { QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/lib/api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // public catalogue data changes slowly; avoid refetch storms on 3G
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      // Don't retry 4xx — they won't fix themselves.
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
})
